import type * as React from 'react';
import { get } from '@Domain/Api';
import auditActionsFetched, {
	type AuditActionsFetchedAction,
	type AuditActionsFetchedPayload,
} from '@Application/AuditTrail/Actions/auditActionsFetched';
import auditActionsFetchFailed, {
	type AuditActionsFetchFailedAction,
} from '@Application/AuditTrail/Actions/auditActionsFetchFailed';
import type FetchAuditActions from '@Application/AuditTrail/Queries/FetchAuditActions';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AuditActionsFetchedAction | AuditActionsFetchFailedAction;

/** A referential list of actions: no tenant, no parameter. */
export default (_query: FetchAuditActions) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AuditActionsFetchedPayload>(
				`${parameters.api.host}/api/enums/audit-actions`,
			);

			const action = auditActionsFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = auditActionsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
